import React, { Component } from 'react'
import Checkbox from "Components/Common/checkbox";
import ProtocolRecordsStore from 'Stores/ProtocolRecords/protocolRecordsStore'
import { observer } from "mobx-react";
import Popup from "Components/Common/popup";
import { ProtocolEventSuccessTypeEnum } from 'Utils/Requests/WebEnums';
import FiltersStore from 'Stores/ProtocolRecords/FiltersStore';

class RecordLine extends Component {
    constructor() {
        super();

        this.state = {
            actionLineExpanded: false,
            prevId: -1,
            blink: false,
            scrolledToBlink: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (state.blink && !state.scrolledToBlink) {
            state.scrolledToBlink = true;
            location.hash = '';
            location.hash = `record-line-${props.record.id}`;
        }

        if (props.record.id !== state.prevId) {
            state = {
                actionLineExpanded: false,
                prevId: props.record.id
            }
        }

        return state;
    }

    render() {
        const { id, regNum, regDate, user, usersAdditional, deviceCode, action, additionalInfo, error, stackTrace, startDate, duration, type } = this.props.record;

        let selected = ProtocolRecordsStore.selectedRecordsIds.some(it => it == id);

        if (ProtocolRecordsStore.blinkItems.some(it => it == id) && !this.state.blink) {
            this.setState({ blink: true });

            setTimeout(function () {
                ProtocolRecordsStore.blinkItems = ProtocolRecordsStore.blinkItems.filter(it => it != id);
                this.setState({ blink: false });
            }.bind(this), 1000)
        }

        let isHasAdditionalInfo = additionalInfo != null && additionalInfo != '';
        let isHasStackTraceText = stackTrace != null && stackTrace != '';
        let isHasErrorText = error != null && error != '';
        let showAdditionalInfoButton = '';
        let expandedDescriptionClass = '';
        if ((type === ProtocolEventSuccessTypeEnum.Success) && (isHasAdditionalInfo || isHasStackTraceText)) {
            showAdditionalInfoButton = (<a className="info-icon" onClick={_ => this.setState({ actionLineExpanded: !this.state.actionLineExpanded })}>инфо</a>);
            expandedDescriptionClass = 'info-description';
        }
        else if ((type === ProtocolEventSuccessTypeEnum.Warning) && (isHasAdditionalInfo || isHasStackTraceText || isHasErrorText)) {
            showAdditionalInfoButton = (<a className="warning-icon" onClick={_ => this.setState({ actionLineExpanded: !this.state.actionLineExpanded })}>инфо</a>);
            expandedDescriptionClass = 'info-description';
        }
        else if ((type === ProtocolEventSuccessTypeEnum.Error) && (isHasAdditionalInfo || isHasStackTraceText || isHasErrorText)) {
            showAdditionalInfoButton = (<a className="error-icon" onClick={_ => this.setState({ actionLineExpanded: !this.state.actionLineExpanded })}>ошибка</a>);
            expandedDescriptionClass = 'error-description';
        }

        let isCanShowStackTrace =
            isHasErrorText
                ? (ProtocolRecordsStore.showTechInfo && isHasStackTraceText)
                : isHasStackTraceText
            ;
        let actionLineExpandedDescription =
            this.state.actionLineExpanded
                ? (
                    <div className={expandedDescriptionClass}>
                        {isHasErrorText
                            ? (<div className="error-title">{error}</div>)
                            : null
                        }
                        {(isHasErrorText && (isHasAdditionalInfo || isCanShowStackTrace))
                            ? (<hr />)
                            : null}
                        {isHasAdditionalInfo
                            ? (<div className="stack-trace" dangerouslySetInnerHTML={{ __html: additionalInfo.split('\n').join('<br/>') }} />)
                            : null
                        }
                        {isCanShowStackTrace
                            ? (<div className="stack-trace" dangerouslySetInnerHTML={{ __html: stackTrace.split('\n').join('<br/>') }} />)
                            : null
                        }
                    </div>
                )
                : null
            ;

        let classFromParent = '';

        if (this.props.className != null)
            classFromParent = this.props.className;

        return (
            <div
                className={
                    "record-line smr-table-line" +
                    (selected ? ' selected' : '') +
                    (type === ProtocolEventSuccessTypeEnum.Error ? ' error-line' : '') +
                    (type === ProtocolEventSuccessTypeEnum.Warning ? ' warning-line' : '') +
                    (this.state.blink ? ' blink' : '')
                }
                id={`record-line-${id}`}>
                <div
                    id={`record-line-without-description-${id}`}
                    className={"record-line-without-description " + classFromParent + (type === ProtocolEventSuccessTypeEnum.Error ? ' error-line' : '')}
                    onClick={() => ProtocolRecordsStore.SelectItemInTable(id, selected == false)}
                >
                    <div className="select-line-column">
                        <Checkbox checked={selected} />
                    </div>
                    <div className="reg-num-column reg-num-column-width">
                        {(regDate == null || regDate === '' ? regNum :
                            <div>
                                {regNum}
                                <br />
                                от
                                <br />
                                {regDate}
                            </div>
                        )}
                    </div>
                    <div className="user-column user-column-width">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className="user-column-text">{user}</div>
                            {
                                usersAdditional?.length > 0 ? (
                                    <Popup
                                        key={id}
                                        className="popup-margin-inline popup-icon-info"
                                        popupText={usersAdditional.map(userAdditional => <div key={userAdditional}>{userAdditional}</div>)}
                                        marginTopAdditionalPx="7"
                                    >
                                        ЕЩЁ
                                    </Popup>
                                ) : ""
                            }
                        </div>
                        <div className="user-column-text">
                            {deviceCode?.length > 0 ? deviceCode : ""}
                        </div>
                    </div>
                    <div className={"action-column-width" + " " + "action-column"}>
                        <p className="wrap-paragraph">
                            {action}
                        </p>
                    </div>
                    <div className="additional-info-button-column additional-info-button-column-width">
                        {showAdditionalInfoButton}
                    </div>
                    <div className="start-date-column start-date-column-width">
                        {startDate}
                    </div>
                </div>
                {actionLineExpandedDescription}
            </div>
        )
    }
}

export default observer(RecordLine);